/**
 * VENDORS DKT FOOTER
 * Reimport all dkt-footer vendors - es6 style
 */

import 'iframe-resizer';
import 'jquery.scrollto';
import 'typeahead.js/dist/typeahead.jquery';
import Bloodhound from 'typeahead.js/dist/bloodhound.min';

// TODO : REMOVE FROM WINDOW SCOPE ! TODO : REFACTO TYPEAHEAD.LEGACY.JS
window.Bloodhound = Bloodhound;

// import 'accounting'; // <= s'attache à la window, ne semble plus servir

// import 'jquery-ui';
import 'jquery-countdown';
import 'jquery-qrcode2'; // ??? not really on npm ???
import jRespond from 'jrespond'; // to shoot ? only used in models

window.jRespond = jRespond;

import 'bootstrap/dist/js/bootstrap';
import 'bootstrap-select/js/bootstrap-select';
import 'jquery-mousewheel';
import 'jquery.panzoom';
import 'js-marker-clusterer';
import 'slick-carousel';
import 'jquery-mask-plugin';

// import 'Imagemapster'; // antiquité non sur npm, et a priori non utilisé
import './old_vendors/moment/moment.legacy';
import './old_vendors/moment/de.legacy';
import './old_vendors/moment/zh-cn.legacy';
import './old_vendors/moment/zh-hk.legacy';
import './old_vendors/moment/nl.legacy';
import './old_vendors/moment/nl-be.legacy';
import './old_vendors/moment/fr.legacy';
import './old_vendors/moment/es.legacy';
import './old_vendors/moment/ca.legacy';
import './old_vendors/moment/it.legacy';
import './old_vendors/moment/pl.legacy';
import './old_vendors/moment/pt.legacy';
import './old_vendors/moment/hu.legacy';
import './old_vendors/moment/tr.legacy';
import './old_vendors/moment/ro.legacy';
import './old_vendors/moment/cs.legacy';
import './old_vendors/bootstrap-datetimepicker.legacy';
// import 'jquery-trap-input'; // TODO : very old, not on npm ?
/* eslint-disable */
import './old_vendors/jquery.trap.legacy'; // TODO : make a PR to the maintener ?
/* eslint-enable */
// import 'jquery-browser-fingerprint'; // TOO : not on npm
import './old_vendors/jquery.browser-fingerprint-1.1.legacy'; // TODO : use another plugin/lib?
// import 'md5'; // TODO : not on npm
import './old_vendors/md5.legacy'; // TODO : use another plugin/lib?



// WEBPACK FOOTER //
// ./src/legacy/vendors-footer.js